module.exports = __webpack_public_path__ + "img/07f1647.png";